import { GUN_CUES, withoutSound, type GunCue, type ScannerSignal } from './gunFeedback'

/**
 * Gun Sounds, on or off (Mark, 2026-10-16, Settings): whether the gun beeps for an accepted
 * scan. Off, the lamps still say everything (green yes, red no, amber new orders); the gun's
 * volume and its decode beep are left as they are, so turning sounds back on needs nothing
 * else.
 *
 * A per-tablet choice kept in this browser, like the tap sound and the gun volume override:
 * on unless it was turned off here.
 */

const GUN_SOUNDS_KEY = 'dockautomation.gunSounds'

type Store = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>

function storage(): Store | null {
  try {
    return globalThis.localStorage ?? null
  } catch {
    return null
  }
}

export function gunSoundsEnabled(store: Store | null = storage()): boolean {
  try {
    return store?.getItem(GUN_SOUNDS_KEY) !== 'off'
  } catch {
    return true
  }
}

export function setGunSounds(enabled: boolean, store: Store | null = storage()): void {
  try {
    if (enabled) store?.removeItem(GUN_SOUNDS_KEY)
    else store?.setItem(GUN_SOUNDS_KEY, 'off')
  } catch {
    // No storage: the choice lasts until the next page load.
  }
}

/** The cues the gun gives on this tablet now: the design's, without the beep when sounds are off. */
export function gunCues(store: Store | null = storage()): Record<ScannerSignal, GunCue> {
  return gunSoundsEnabled(store) ? GUN_CUES : withoutSound(GUN_CUES)
}
